import React, { useEffect } from 'react';

const useCacheInputFilterValue = (inputFilter) => {
  const inflv =
    sessionStorage.getItem('inflv') &&
    JSON.parse(sessionStorage.getItem('inflv'));

  useEffect(() => {
    if (inputFilter !== null && inputFilter !== undefined) {
      if (!inflv || inputFilter !== inflv) {
        sessionStorage.setItem(
          'inflv',
          JSON.stringify(inputFilter)
        );
      }
    }
  }, [inputFilter]);
};

export default useCacheInputFilterValue;
